module.exports = __webpack_public_path__ + "img/tombstone.27c90264.svg";